var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBriefcaseYellow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9605 3.65789H11.8026V2.07895C11.8026 1.20263 11.1 0.5 10.2237 0.5H7.06579C6.18947 0.5 5.48684 1.20263 5.48684 2.07895V3.65789H2.32895C1.45263 3.65789 0.757895 4.36053 0.757895 5.23684L0.75 13.9211C0.75 14.7974 1.45263 15.5 2.32895 15.5H14.9605C15.8368 15.5 16.5395 14.7974 16.5395 13.9211V5.23684C16.5395 4.36053 15.8368 3.65789 14.9605 3.65789ZM10.2237 3.65789H7.06579V2.07895H10.2237V3.65789Z",
    fill: "#FFAB00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBriefcaseYellow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/briefcase_yellow.4e926526.svg";
export { ForwardRef as ReactComponent };